import { post } from '../httpClient';

export const googleStorageAPI = {
  images: {
    upload: body => post('/api/google-storage/images/upload', body),
  },
  documents: {
    upload: body => post('/api/google-storage/documents/upload', body),
  },
  videos: {
    upload: body => post('/api/google-storage/videos/upload', body),
  },
};